import Axios from 'axios'
import store from './index'
import { createBasicAuthConfig } from '../util/api'

const defaultState = () => ({
  isModalOpened: false,
  selectedRecord: null
})

export default {
  namespaced: true,
  state: defaultState(),
  mutations: {
    openModal(state, record) {
      state.isModalOpened = true
      state.selectedRecord = record
    },
    closeModal(state) {
      state.isModalOpened = false
    },
    reset(state) {
      Object.assign(state, defaultState())
    },
    editSelectedRecord(state, object) {
      //convert "" property to null
      Object.keys(object).map((key)=>{
        if (object[key] === ''){
          object[key]=null
        }
      })
      Object.assign(state.selectedRecord, object)
    }
  },
  actions: {
    async editPaper(bigStuff, reqBody) {
      const SERVER_ADDRESS = this._vm.$config[process.env.NODE_ENV].SERVER_ADDRESS
      const API = this._vm.$config[process.env.NODE_ENV].API
      const url = SERVER_ADDRESS + API.EDIT_PAPER
      const json = JSON.stringify(reqBody)
      const config = createBasicAuthConfig(
        store.state.authentication.token
      )
      config.headers['Content-Type'] = 'application/json'

      let result = {}
      await Axios.post(
        url, json, config
      ).then((resp) => {
        result = resp.data
      }).catch((err) => {
        result = err.response.data
      })
      return result
    },
    async deletePaper(bigStuff, reqBody){
      const SERVER_ADDRESS = this._vm.$config[process.env.NODE_ENV].SERVER_ADDRESS
      const API = this._vm.$config[process.env.NODE_ENV].API
      const url = SERVER_ADDRESS + API.DELETE_PAPER
      const json = JSON.stringify(reqBody)
      const config = createBasicAuthConfig(
        store.state.authentication.token
      )
      config.headers['Content-Type'] = 'application/json'

      let result = {}
      await Axios.post(
        url, json, config
      ).then((resp) => {
        result = resp.data
      }).catch((err) => {
        result = err.response.data
      })
      return result
    }
  }

}